export default __webpack_public_path__ + "static/media/progress_3.4102945e.svg";